/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import { Link } from 'react-router';
import CSSModules from 'react-css-modules';

import FullWidthRegion from './FullWidthRegion';
import ImageInfo from './ImageInfo';

import styles from './Featured.css';
import * as library from '../lib/library';

//
// constructed narrative
// symmetry
// sculpture
// exercise in formal comp.
// pretty sure this is exactly right

class Featured extends Component {
  render() {
    const featured = [
      library.getSeriesById('an-exercise-in-formal-composition'),
      library.getSeriesById('constructed-narrative'),
      library.getSeriesById('flowers-and-fabric'),
      library.getSeriesById('other'),
      library.getSeriesById('symmetry'),
      library.getSeriesById('installation'),
    ].map((item) => {
      const type = item.works ? 'series' : 'work';

      // TODO: Get thumbnail URL for preview image:
      let src;
      let worksInSeries;
      let url;

      if (type === 'series') {
        worksInSeries = item.works.length;

        const firstWorkInSeries = library.getWorkById(item.works[0]);
        src = firstWorkInSeries.images[0].src;
        url = `/works/${firstWorkInSeries.id}`;
      } else {
        src = item.images[0].src;
        // TODO: url
      }

      return {
        type,
        src,
        url,
        id: item.id,
        title: item.title,
        count: worksInSeries,
      };
    });

    return (
      <div styleName="wrapper">
        <FullWidthRegion>
          <h2 styleName="title">Featured Works</h2>
          <ul styleName="featured">
            {
              featured.map(item => (
                <li styleName="grid-item" key={item.src}>
                  <div styleName="preceived-item">
                    <Link
                      target="_self"
                      styleName="image-wrapper"
                      to={item.url}
                      style={{ backgroundImage: `url(${item.src})` }}
                    />
                    <ImageInfo href={item.url} labelText={item.title} badgeText={`${item.count} Works`} />
                  </div>
                </li>
                ))
            }
          </ul>
        </FullWidthRegion>
      </div>
    );
  }
}

export default CSSModules(Featured, styles, { errorWhenNotFound: false });



// WEBPACK FOOTER //
// ./application/js/components/Featured.js